import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
// Replace these values with your actual Firebase project configuration
const firebaseConfig = {
    apiKey: "AIzaSyD3Z3G5GRfjRwOWRPpKh-fqK2u57eAv1qY",
    authDomain: "syrdevuae.firebaseapp.com",
    projectId: "syrdevuae",
    storageBucket: "syrdevuae.firebasestorage.app",
    messagingSenderId: "791851995104",
    appId: "1:791851995104:web:7ad4fbe4807ba12c87a585",
    measurementId: "G-9W92M7GMJT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

// Initialize Storage
export const storage = getStorage(app);

export default app; 